import { connect } from 'react-redux'
import { switchAuthStatus, handleMenu, handleClose, selectCategoryAndFetchPosts, selectLocation, toggleNavDrawer, toggleLoginDialog, setUser } from '../actions/index'
import ComponentAppBar from '../components/ComponentAppBar'

const mapStateToProps = (state, ownProps) => {
    const { auth, anchorEl, selectedCategory, selectedLocation, user } = state
    
    return { auth, anchorEl, selectedCategory, selectedLocation, user }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
    dispatch: dispatch,
    switchAuthStatus: (checked) => dispatch(switchAuthStatus(checked)),
    handleMenu: event => dispatch(handleMenu(event)),
    handleClose: () =>  dispatch(handleClose()),
    handleCategoryChange: (selectedOption, history) => dispatch(selectCategoryAndFetchPosts(selectedOption ? selectedOption.value : null, history)),
    handleLocationChange: selectedLocation => dispatch(selectLocation(selectedLocation)),
    toggleNavDrawer: isOpen => dispatch(toggleNavDrawer(isOpen)),
    toggleLoginDialog: isOpen => dispatch(toggleLoginDialog(isOpen)),
    setUser: user => dispatch(setUser(user))
})

const ContainerAppBar = connect(
  mapStateToProps,
  mapDispatchToProps
)(ComponentAppBar)

export default ContainerAppBar


// WEBPACK FOOTER //
// ./src/containers/ContainerAppBar.js